/**
 * 185 / 65.27: hit locations and armour — every value one line, tuned in play (the owner: headshots "as designed, tune in
 * play"; the Lab's dials set the head's and the limbs' multipliers).
 *
 * HIT_LOCATION: where a hit lands, from its height over the feet as a share of the stance's body (the top of its capsule):
 * the head from `headFrom` up, the limbs below `limbsBelow`, or (on the measured body) more than `armsOff` of its radius
 * off its axis; prone, along its length — the front `proneHead` the head, the back `proneLimbs` the limbs. `multiplier`:
 * × the round's damage there (health 100, a 7.62 does 20: two to the head, five to the body, nine to the limbs).
 *
 * ARMOUR: each piece's life (worn by the damage it stops; spent at 0) and the share of a hit it stops by the round (179's
 * cartridges) or a blast; a heavy vest walks at `heavyCarry`, a heavy helmet at `heavyHelmetCarry` (× each other). A blast meets the helmet over `blastHead` of it — the head's share of
 * the hits measured in play (12 %; 65.27) — at the helmet's blast share (65.35 step 8).
 */
import type { CartridgeKind } from '../types/player';

export const HIT_LOCATION = { headFrom: 0.84, limbsBelow: 0.45, armsOff: 0.8, proneHead: 0.2, proneLimbs: 0.4, multiplier: { head: 2.5, body: 1, limbs: 0.6 } };

type Stops = Record<CartridgeKind | 'blast', number>;
type Piece = 'helmet' | 'heavyHelmet' | 'light' | 'heavy';
/** (190: the heavy helmet — full-cut, a mandible guard: twice the light one's life, more of a rifle round stopped; it walks at `heavyHelmetCarry`.) */
export const ARMOUR: { life: Record<Piece, number>; stops: Record<Piece, Stops>; heavyCarry: number; heavyHelmetCarry: number; blastHead: number } = {
  life: { helmet: 40, heavyHelmet: 80, light: 80, heavy: 160 },
  stops: {
    helmet: { '9mm': 0.8, '5.56': 0.45, '7.62': 0.35, '.50': 0, blast: 0.4, '.30-06': 0.3, '.45': 0.8 },
    heavyHelmet: { '9mm': 0.9, '5.56': 0.65, '7.62': 0.55, '.50': 0.1, blast: 0.5, '.30-06': 0.5, '.45': 0.9 },
    light: { '9mm': 0.7, '5.56': 0.35, '7.62': 0.25, '.50': 0, blast: 0.3, '.30-06': 0.22, '.45': 0.7 },
    heavy: { '9mm': 0.9, '5.56': 0.7, '7.62': 0.6, '.50': 0.15, blast: 0.5, '.30-06': 0.55, '.45': 0.9 },   // (65.43: the .30-06 a little past the 7.62, the .45 a pistol round)
  },
  heavyCarry: 0.92,
  heavyHelmetCarry: 0.97,
  blastHead: 0.12,
};
